import { h } from '@stencil/core';
import type { ObservableMap } from '@stencil/store';

import type { MatchStoreState } from '../../../../../services/interfaces';
import {
  firstLegResultPreMatch,
  matchAggregate,
  matchReasonOfWinDisplayText,
  setCssVariant,
} from '../../helpers/match-unit.helpers';

type Props = {
  state: ObservableMap<MatchStoreState>['state'];
};

const MatchRelated = ({ state }: Props) => {
  const cssVariant = setCssVariant(state.size);
  const match = state.matchData;
  const hideContext = state.hideContext;

  if (!match || hideContext) return null;

  return (
    <div class={{ 'pk-match__related': true, ...cssVariant }} part="match-related">
      <MatchFirstLegResult state={state} />
      <MatchAggResult state={state} />
      <MatchPostStatus state={state} />
    </div>
  );
};

const MatchFirstLegResult = ({ state }: Props) => {
  const cssVariant = setCssVariant(state.size);
  const match = state.matchData;
  const hideContext = state.hideContext;

  if (!match || hideContext) return null;

  const firstLegResult = firstLegResultPreMatch(match);
  const matchAggregateResult = matchAggregate(match);
  if (!firstLegResult || matchAggregateResult) return null;

  return (
    <span class={{ 'pk-match__related--results': true, ...cssVariant }} part="related">
      {firstLegResult ?? ''}
    </span>
  );
};

const MatchAggResult = ({ state }: Props) => {
  const cssVariant = setCssVariant(state.size);

  const match = state.matchData;
  const hideContext = state.hideContext;
  const matchAggregateResult = matchAggregate(match);

  if (!matchAggregateResult || hideContext) return null;

  return (
    <span class={{ 'pk-match__related--agg-score': true, ...cssVariant }} part="agg-score">
      {matchAggregateResult}
    </span>
  );
};

const MatchPostStatus = ({ state }: Props) => {
  const cssVariant = setCssVariant(state.size);

  const match = state.matchData;
  const hideContext = state.hideContext;
  const reasonOfWin = matchReasonOfWinDisplayText(match);

  if (!reasonOfWin || hideContext) return null;

  return (
    <span class={{ 'pk-match__related--post-status': true, ...cssVariant }} part="post-status">
      {reasonOfWin}
    </span>
  );
};

export { MatchRelated, MatchAggResult, MatchPostStatus, MatchFirstLegResult };
